<template>
  <div class="scroll-marquee-background">
    <AppScrollMarquee>
      <span
        class="scroll-marquee-background__marquee"
        :class="{ 'scroll-marquee-background__marquee--no-small': !small }"
      >{{ title }}</span>
    </AppScrollMarquee>
    <AppScrollMarquee :reverse="true">
      <span
        class="scroll-marquee-background__marquee"
        :class="{ 'scroll-marquee-background__marquee--no-small': !small }"
      >{{ title }}</span>
    </AppScrollMarquee>
  </div>
</template>

<script setup lang="ts">

defineProps({
  title: { type: String, default: undefined, required: false },
  small: { type: Boolean, default: false }
})

</script>

<style scoped lang="postcss">
.scroll-marquee-background {
  position: fixed;
  left: 0px;
  top: 50%;
  z-index: -1;
  width: 100%;
  transform: translateY(-50%);

  &__marquee {
    padding-right: 3rem;
    font-family: Midnight, sans-serif;
    font-size: 100px;
    text-transform: uppercase;
    line-height: 0.8;
    color: var(--color-blue-prussian);
    text-shadow: -1px -1px 0 #00ffe0, 1px -1px 0 #00ffe0, -1px 1px 0 #00ffe0, 1px 1px 0 #00ffe0;

    @media (--md) {
      font-size: 120px;

      &--no-small {
        font-size: 140px;
      }
    }

    @media (--lg) {
      font-size: 140px;

      &--no-small {
        font-size: 180px;
      }
    }
  }
}
</style>
